module.exports = __webpack_public_path__ + "img/180-Pastel Green.jpg";